/**
 *
 * @module Enums
 *
 * @preferred
 *
 * @description Module for enums types defined in SenseNet helps you to use enums with dot notation.
 *
 * This module is autogenerated from Sense/Net metadata (/Odata/$metadata)
 *
 * ```
 * let car = new ContentTypes.Car({
 *  Id: 1,
 *  Name: 'MyCar',
 *  DisplayName: 'My Car',
 *  Style: Style.Cabrio
 * });
 * ```
 */

export let VersioningMode;
(function (VersioningMode) {
  VersioningMode["Option0"] = "0";
  VersioningMode["Option1"] = "1";
  VersioningMode["Option2"] = "2";
  VersioningMode["Option3"] = "3";
})(VersioningMode || (VersioningMode = {}));
export let InheritableVersioningMode;
(function (InheritableVersioningMode) {
  InheritableVersioningMode["Option0"] = "0";
  InheritableVersioningMode["Option1"] = "1";
  InheritableVersioningMode["Option2"] = "2";
  InheritableVersioningMode["Option3"] = "3";
})(InheritableVersioningMode || (InheritableVersioningMode = {}));
export let ApprovingMode;
(function (ApprovingMode) {
  ApprovingMode["Option0"] = "0";
  ApprovingMode["Option1"] = "1";
  ApprovingMode["Option2"] = "2";
})(ApprovingMode || (ApprovingMode = {}));
export let InheritableApprovingMode;
(function (InheritableApprovingMode) {
  InheritableApprovingMode["Option0"] = "0";
  InheritableApprovingMode["Option1"] = "1";
  InheritableApprovingMode["Option2"] = "2";
})(InheritableApprovingMode || (InheritableApprovingMode = {}));
export let SavingState;
(function (SavingState) {
  SavingState["Finalized"] = "0";
  SavingState["Creating"] = "1";
  SavingState["Modifying"] = "2";
  SavingState["ModifyingLocked"] = "3";
})(SavingState || (SavingState = {}));
export let GroupAttachments;
(function (GroupAttachments) {
  GroupAttachments["email"] = "email";
  GroupAttachments["root"] = "root";
  GroupAttachments["subject"] = "subject";
  GroupAttachments["sender"] = "sender";
})(GroupAttachments || (GroupAttachments = {}));
export let EnableAutofilters;
(function (EnableAutofilters) {
  EnableAutofilters["Default"] = "0";
  EnableAutofilters["Enabled"] = "1";
  EnableAutofilters["Disabled"] = "2";
})(EnableAutofilters || (EnableAutofilters = {}));
export let EnableLifespanFilter;
(function (EnableLifespanFilter) {
  EnableLifespanFilter["Default"] = "0";
  EnableLifespanFilter["Enabled"] = "1";
  EnableLifespanFilter["Disabled"] = "2";
})(EnableLifespanFilter || (EnableLifespanFilter = {}));
export let Language;
(function (Language) {
  Language["En"] = "en";
  Language["Hu"] = "hu";
})(Language || (Language = {}));
export let MemoType;
(function (MemoType) {
  MemoType["generic"] = "generic";
  MemoType["iso"] = "iso";
  MemoType["iaudit"] = "iaudit";
})(MemoType || (MemoType = {}));
export let Priority;
(function (Priority) {
  Priority["Option0"] = "1";
  Priority["Option1"] = "2";
  Priority["Option2"] = "3";
})(Priority || (Priority = {}));
export let Status;
(function (Status) {
  Status["pending"] = "pending";
  Status["active"] = "active";
  Status["completed"] = "completed";
  Status["deferred"] = "deferred";
  Status["waiting"] = "waiting";
})(Status || (Status = {}));
export let QueryType;
(function (QueryType) {
  QueryType["Public"] = "Public";
  QueryType["Private"] = "Private";
})(QueryType || (QueryType = {}));
export let Gender;
(function (Gender) {
  Gender["Option0"] = "...";
  Gender["Female"] = "Female";
  Gender["Male"] = "Male";
})(Gender || (Gender = {}));
export let MaritalStatus;
(function (MaritalStatus) {
  MaritalStatus["Option0"] = "...";
  MaritalStatus["Single"] = "Single";
  MaritalStatus["Married"] = "Married";
})(MaritalStatus || (MaritalStatus = {}));
export let EventType;
(function (EventType) {
  EventType["Deadline"] = "Deadline";
  EventType["Meeting"] = "Meeting";
  EventType["Demo"] = "Demo";
})(EventType || (EventType = {}));
//# sourceMappingURL=Enums.js.map